import { render, staticRenderFns } from "./SateliteItem.vue?vue&type=template&id=73a5ce7e&"
import script from "./SateliteItem.vue?vue&type=script&lang=ts&"
export * from "./SateliteItem.vue?vue&type=script&lang=ts&"
import style0 from "./SateliteItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCardText,VForm})
